import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKanbanView = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	stroke: "current",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0 1C0 0.447716 0.447715 0 1 0H8.33348C8.88576 0 9.33348 0.447715 9.33348 1V8.33348C9.33348 8.88576 8.88576 9.33348 8.33348 9.33348H1C0.447716 9.33348 0 8.88576 0 8.33348V1Z",
			fill: "current"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6666 1C10.6666 0.447716 11.1143 0 11.6666 0H19.0001C19.5524 0 20.0001 0.447715 20.0001 1V8.33348C20.0001 8.88576 19.5524 9.33348 19.0001 9.33348H11.6666C11.1143 9.33348 10.6666 8.88576 10.6666 8.33348V1Z",
			fill: "current"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 11.6661C0 11.1138 0.447715 10.6661 1 10.6661H8.33348C8.88576 10.6661 9.33348 11.1138 9.33348 11.6661V18.9996C9.33348 19.5519 8.88576 19.9996 8.33348 19.9996H1C0.447716 19.9996 0 19.5519 0 18.9996V11.6661Z",
			fill: "current"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6666 11.6661C10.6666 11.1138 11.1143 10.6661 11.6666 10.6661H19.0001C19.5524 10.6661 20.0001 11.1138 20.0001 11.6661V18.9996C20.0001 19.5519 19.5524 19.9996 19.0001 19.9996H11.6666C11.1143 19.9996 10.6666 19.5519 10.6666 18.9996V11.6661Z",
			fill: "current"
		})
	]
});
const ForwardRef = forwardRef(SvgKanbanView);
export { ForwardRef as ReactComponent };
